import { AxiosError, AxiosResponse } from "axios";
import { DataType, FieldType } from "@websential/cosmic-v20";
import { IGetListRequest, IResponse, IServerError } from "../../models/common";
import { IUserListPayload, IUserResponse, IUsers } from "../../models";

import { GridSize } from "@mui/material";
import { IDropDownListResponse } from "../../models/common/IDropDownListResponse";
import http from "../../common/http-commons";

// import { IFixedAndMetaField } from 'common/FlexFieldsUtils';

// import { IVendorListPayload, IVendorRequest, IVendorResponse } from 'models/vendor';
// import { CLIENT_SETUP_FORM, CLIENT_SETUP_FORM_FOR_ADMIN_USER } from 'userLayoutData/client';

// import { IAPIKeysRequest, IAPIKeysResponse } from '../models';

// import { IUsersListPayload, IUsersRequest, IUsersResponse } from '../models/user';

// import { INITIAL_PAGE_SIZE } from 'common/constants';

export const UsersService = {
  getUser: async (
    data: IGetListRequest,
    navigateToLogout: (path: string) => void,
  ): Promise<IUserListPayload | IServerError | IResponse | IUserResponse[]> => {
    try {
      const response: AxiosResponse<IUserListPayload> =
        await http.get<IUserListPayload>(
          "/v1/user/" +
            "?order_by=" +
            data.order_by +
            "&order_direction=" +
            data.order_direction +
            "&page=" +
            data.page +
            "&size=" +
            data.size +
            "&search_query=" +
            data.search_query,
        );

      if (response.status === 200) {
        return response.data;
      } else if (response.status === 400) {
        return {
          status: false,
          message: "Bad Request.",
          error: true,
        };
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }
      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 401) {
        navigateToLogout("/logout");
        return {
          status: false,
          message: "UnAuthrized",
        };
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },
  getById: async (
    id: string | undefined,
    navigateToLogout: (path: string) => void,
  ): Promise<IUsers | IServerError | IResponse | null | any> => {
    if (!id) return null;
    try {
      const response: AxiosResponse<IUsers> = await http.get<IUsers>(
        `/v1/user/${id}/`,
      );

      if (response.status === 200) {
        return response.data;
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 401) {
        navigateToLogout("/logout");
        return {
          status: false,
          message: "UnAuthrized",
        };
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },
  create: async (
    requestPayload: any,
  ): Promise<IUsers | IServerError | IResponse | any> => {
    if (requestPayload.id) {
      try {
        const response: AxiosResponse<IUsers> = await http.put<IUsers>(
          `/v1/user/${requestPayload.id}/?client_id=${requestPayload.clientId}`,
          requestPayload,
        );

        if (response.status === 200) {
          return response;
        } else if (response.status === 400) {
          return response.data;
        } else if (response.status === 500) {
          return {
            status: false,
            message: "Something went wrong.",
            error: true,
          };
        }
      } catch (error) {
        const axiosError = error as AxiosError;
        console.error("An error occurred:", axiosError);
        const errorMessage =
          axiosError.response && typeof axiosError.response.data === "string"
            ? axiosError.response.data
            : "Unknown error";
        if (axiosError && axiosError.status === 401) {
          requestPayload.navigateToLogout("/logout");
          return {
            status: false,
            message: "UnAuthrized",
          };
        } else {
          return {
            status: false,
            message: errorMessage,
          };
        }
      }
    }

    try {
      const response: AxiosResponse<IUsers> = await http.post<IUsers>(
        `/v1/user/?client_id=${requestPayload.clientId}`,
        requestPayload,
      );

      if (response.status === 201) {
        return response;
      } else if (response.status === 400) {
        return response.data;
      } else if (response.status === 401) {
        // window.location.href = '/logout';
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 401) {
        requestPayload.navigateToLogout("/logout");
        return {
          status: false,
          message: "UnAuthrized",
        };
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },
  delUser: async (
    delPayload: any,
  ): Promise<string | IServerError | IResponse | any> => {
    // return new Promise(resolve => setTimeout(() => resolve("Flex Field has been deleted successfully"), 1000));
    try {
      const response: AxiosResponse<string> = await http.delete<string>(
        `/v1/user/${delPayload.userId}/`,
      );

      if (response.status === 204) {
        return "User has been deleted successfully";
      } else if (response.status === 200) {
        return "User has been deleted successfully";
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 401) {
        delPayload.navigateToLogout("/logout");
        return {
          status: false,
          message: "UnAuthrized",
        };
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },
  delBulkUseres: async (
    requestPayload: any,
  ): Promise<string | IServerError | IResponse> => {
    try {
      const response = await http.delete<string>(`/v1/user/`, {
        data: requestPayload.userIds,
      });
      if (response.status === 200) {
        return response.data;
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 401) {
        requestPayload.navigateToLogout("/logout");
        return {
          status: false,
          message: "UnAuthrized",
        };
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },
  getGetUserDDL: async (): Promise<any | IServerError | IResponse | null> => {
    const response: AxiosResponse<any[]> =
      await http.get<any[]>(`/v1/user/user-ddl`);

    if (response.status === 200) {
      return response.data;
    }

    return {
      status: false,
      message: "Something went wrong please try again later.",
    };
  },
  archiveUser: async (
    archivePayload: any,
  ): Promise<string | IServerError | IResponse | any> => {
    // return new Promise(resolve => setTimeout(() => resolve("Flex Field has been deleted successfully"), 1000));
    try {
      const response: AxiosResponse<string> = await http.post<string>(
        `/v1/user/${archivePayload.userId}/`,
      );

      if (response.status === 201) {
        return "User has been archived successfully";
      } else if (response.status === 200) {
        return "User has been archived successfully";
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 401) {
        archivePayload.navigateToLogout("/logout");
        return {
          status: false,
          message: "UnAuthrized",
        };
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },
  getUserDDL: async (): Promise<any | IServerError | IResponse | null> => {
    try {
      const response: AxiosResponse<IDropDownListResponse[]> =
        await http.get<IDropDownListResponse[]>(`/v1/user/ddl`);
      if (response.status === 200) {
        return response.data;
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch {}
  },
};
